import React from "react";
import { Redirect } from "react-router-dom";
import { userAttribs } from "src/common/utils/userAttribs4mLocalStorage";

interface Props {
  children: React.ReactNode;
  redirectPath: string;
  path: string;
}

export function UnAuthGuard(props: Props) {
  if (userAttribs()) {
    return !JSON.parse(localStorage.getItem("allowedRoutes") || "").length ? (
      <>{props.children}</>
    ) : (
      <Redirect to={{ pathname: localStorage.getItem("defaultRoute") || "" }} />
    );
  } else {
    return <Redirect to={{ pathname: props.redirectPath }} />;
  }
}
